import { Slide } from "react-slideshow-image";
import React from "react";
import "./Metric.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faClipboardList,
  faCalendarCheck
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

export const Metricsp = (props) => {
  const { data } = props;
  const { t } = useTranslation();

  return (
    <>
      <div className="metrics">
        <div className="metrics-info home-info">
          <h3>{t("metric")}</h3>
          {/* <p>View all</p> */}
        </div>
      </div>
      <div className="metrics-container">
        <Slide
          slidesToScroll={2}
          indicators={true}
          slidesToShow={2}
          arrows={false}
        >
          <div className="slide">
            <div className="slideData">
              <div className="metric-icon sessions-icon">
                <FontAwesomeIcon icon={faClipboardList} />
              </div>
              <div className="card-info">
                <h3>{t("executedsession")}</h3>
                <p className="card-info-main">
                  {data?.totalTrainingSessionsConducted || 0}
                </p>
              </div>
              {/* <p className="update-date">Last updated {data?.last_update}</p> */}
            </div>
          </div>
          <div className="slide">
            <div className="slideData">
              <div className="metric-icon next-sessions-icon">
                <FontAwesomeIcon icon={faCalendarCheck} />
              </div>
              <div className="card-info">
                <h3>{t("nextsession")}</h3>
                <p className="card-info-main">
                  {data?.nextMonthTrainingSessions || 0}
                </p>
              </div>
              {/* <p className="update-date">Last updated {data?.last_update}</p> */}
            </div>
          </div>
          <div className="slide">
            <div className="slideData">
              <div className="metric-icon groups-icon">
                <FontAwesomeIcon icon={faUsers} />
              </div>
              <div className="card-info">
                <h3>{t("totalgrp")}</h3>
                <p className="card-info-main">
                  {data?.totalGroups || 0}
                </p>
              </div>
              {/* <p className="update-date">Last updated {data?.last_update}</p> */}
            </div>
          </div>
        </Slide>
      </div>
    </>
  );
};
